// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors-cc138f38df113f3d9192.js";
	// return url for filenames based on template
	return "" + ({"644":"__federation_expose_plan_list","943":"__federation_expose_handlers"}[chunkId] || chunkId) + "-" + {"474":"8a6aaae6b10bcf677bc8","644":"e7142ad9a39569460d8a","943":"fb5bafaacb801d12582d"}[chunkId] + ".js";
};